module.exports = __webpack_public_path__ + "img/qiche.f2623a35.jpg";